import React from 'react';
import { availabilityBadge } from './availability';

export default function ChallengerCard({ engineer, score, onClick }) {
  if (!engineer) {
    return (
      <div className="challenger-card challenger-card--empty" aria-hidden>
        <div className="challenger-card__photo">
          <span style={{ fontSize: 11, color: 'var(--hai-muted)' }}>?</span>
        </div>
        <div className="challenger-card__name" style={{ color: 'var(--hai-muted)' }}>—</div>
      </div>
    );
  }

  const topAbility = engineer.signatureAbilities?.[0];
  const avail = availabilityBadge(engineer.beschikbaarheid);

  return (
    <button
      type="button"
      className="challenger-card"
      onClick={onClick}
      aria-label={`Wissel naar ${engineer.name}`}
    >
      <div className="challenger-card__photo">
        {engineer.photo
          ? <img src={engineer.photo} alt="" />
          : <span style={{ fontSize: 11, color: 'var(--hai-muted)' }}>{engineer.name?.[0]}</span>}
      </div>
      <div className="challenger-card__name">{engineer.name}</div>
      {topAbility && (
        <div className="challenger-card__ability">
          {topAbility.emoji} {topAbility.name}
        </div>
      )}
      <div className="challenger-card__score">
        match <b>{typeof score === 'number' ? `${score}%` : '—'}</b>
      </div>
      {avail && (
        <div className="challenger-card__avail">
          <span className={`avail-badge avail-badge--${avail.statusKey}`} title={avail.title}>● {avail.label}</span>
        </div>
      )}
    </button>
  );
}
